export default __webpack_public_path__ + "media/images/space-bg-bdd5a126cda2eedc24f7bf21c4fa1ebd.jpg";